import { customer } from "@api/orderings/customer/path";
import { employeeCost } from "@api/orderings/employeeCost/path";
import { measurementUnit } from "@api/orderings/measurementUnit/path";
import { paidInstallment } from "@api/orderings/paidInstallment/path";
import { productCategory } from "@api/orderings/productCategory/path";
import { productPlan } from "@api/orderings/productPlan/path";
import { purchaseInvoices } from "@api/orderings/purchaseInvoices/path";
import { salesInvoices } from "@api/orderings/salesInvoices/path";
import { store } from "@api/orderings/store/path";
import { storeCost } from "@api/orderings/storeCost/path";
import { subscription } from "@api/orderings/subscription/path";
import { supplier } from "@api/orderings/supplier/path";
import { unpaidInstallment } from "@api/orderings/unpaidInstallment/path";
import { user } from "@api/orderings/user/path";
import { warehouse } from "@api/orderings/warehouse/path";

export const orderings = {
  productPlan,
  store,
  subscription,
  paidInstallment,
  unpaidInstallment,
  warehouse,
  productCategory,
  measurementUnit,
  user,
  customer,
  supplier,
  storeCost,
  employeeCost,
  purchaseInvoices,
  salesInvoices,
};
